import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditModalComponent } from 'src/app/shared-components/add-edit-modal/add-edit-modal.component';
import { UserService, ProjectService, ToastService, WorkspaceService } from 'src/app/services';
import { ModalInfo, ElementPath, ExecutionResponse, Tool } from 'src/app/models';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { getToolIcon, ToolType } from 'src/app/resources/tool-utils';
import { AddEditModalSFRComponent } from '../../tools-components/add-edit-modal-SFR/add-edit-modal-SFR.component';
import { SFRSendEmailManagerService } from '../../services/sfr-sendemailmanager.service';
import { AddEditSwitchComponent } from 'src/app/shared-components/add-edit-switch-modal/add-edit-switch-modal.component';
import { AddEditModalPNRRComponent } from '../../tools-components/add-edit-modal-PNRR/add-edit-modal-PNRR.component';
import { PnrrToolService } from '../../services/pnrr-tool.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit, OnDestroy {

  @Output() sendStatusToParent: EventEmitter<ModalInfo> = new EventEmitter();
  getIcon = getToolIcon;

  tools: Tool[] = [];
  modalData: ModalInfo;
  private routerSub: Subscription;
  path: ElementPath = {
    id: undefined,
    type: undefined,
    name: undefined,
  };
  userRole: string = "";
  userToolsRoles=null;
  user_id: string;
  constructor(
    private userService: UserService,
    private projectService: ProjectService,
    private workspaceService: WorkspaceService,
    private toastService: ToastService,
    private router: Router,
      private modalService: NgbModal,
      private sfr: SFRSendEmailManagerService,
      private pnrr: PnrrToolService
  ) {
    this.routerSub = router.events.pipe(
      filter(event => {
        return event instanceof NavigationEnd;
      }),
    ).subscribe(async (event: NavigationEnd) => {
      const path = event.url.split('/');
      this.path.id = path[2] || null;
      this.path.type = path[1] || null;
      if (this.path.id && this.path.type && (
        this.path.type === 'workspace' || this.path.type === 'project' || this.path.type === 'directory')) {
        this.workspaceService.getInfoEntity(this.path.id, this.path.type).then(
          res => {
            this.path.name = res.name;
          }
        ).catch(
          err => err
        );
      } else {
        this.path = {
          id: undefined,
          type: undefined,
          name: undefined,
        };
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  async ngOnInit() {
    try {
      this.tools = (await this.userService.getUserTool()).tools;
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
    //retrieve user's role to discriminate tool routing
    try {
      var u=await this.userService.getUserInfo()
      this.userRole = u.role;
      this.user_id=u.id
      this.userToolsRoles=await this.userService.getToolsAndPrivileges(u);
      // console.log(this.userToolsRoles)
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }
  /**
   * Opens the modal to create a new execution from the buttons
   * of the different tools in the various points of the dashboard and,
   * after creating the execution, redirects to the file upload page
   * @param tool Selected tool
   */

    

    async openModal(tool: Tool) {
      // console.log('open modal')
      const modalData = {
        name: 'New Execution',
        entityName: this.path.name ? 'Execution ' + this.path.name + ' <add custom name here>' : null,
        companyName: 'Company name',
        type: 'execution',
        selector: 'execution',
        buttonName: 'Create',
        collaborators: false,
        is_new: 'true',
        id_entity: tool.id,
        toolName: tool.name,
        id_parent: this.path.id || null,
        type_parent: this.path.type || null,
        name_parent: this.path.type !== 'workspace' && this.path.name || null,
        subtitleInput: 'An execution must be in workspace › project › folder'
      };

      if (tool.name == ToolType.IAS19){
        var access_level_ias=this.userToolsRoles.tool_privileges.find(x=>x.tool_informations.label==ToolType.IAS19).access_level
        this.router.navigate([`/tool/ias/dashboard/${access_level_ias}`]);
      }
      else if (tool.name == ToolType.OPV){
          this.router.navigate([`/tool/opv-dashboard`]);
      }
      else{
        let  modalRef;
          if (tool.name === ToolType.SFR) {
              modalRef = this.modalService.open(AddEditModalSFRComponent, { centered: true, backdrop: 'static' });
              modalRef.componentInstance.submit.subscribe(this.onClose_SFRModal_generator(tool));
              modalRef.componentInstance.data = modalData;
              return;
          }
          if (tool.name == ToolType.PNRR) {
              let routingInfo = (await this.pnrr.getRoutingInfo() as any);
              if (routingInfo?.role == 'bank' || routingInfo?.role == 'admin_ey' || routingInfo?.role == 'user_ey') {
                  modalRef = this.modalService.open(AddEditModalPNRRComponent, { centered: true, backdrop: 'static' });
                  modalRef.componentInstance.submit.subscribe(this.onClose_PNRRModal_generator(tool));
                  modalRef.componentInstance.data = modalData;
                  return;
              } 
              else return;
          } else{
              modalRef = this.modalService.open(AddEditModalComponent, { centered: true, backdrop: 'static' });
              modalRef.componentInstance.submit.subscribe(this.onClose_normalModal_generator(tool));
          }
          // console.log(modalRef)
        
        modalRef.componentInstance.data = modalData;
        }
      
      
    }

    onClose_PNRRModal_generator(tool) {
        return async (receivedEntry) => {
            //console.log("hi")

            if (receivedEntry?.action_type == "template-generator") {
                this.router.navigate([`/execution/ach/template-gen-pnrr`]);
            }
            if (receivedEntry?.action_type == "dashboard") {
                this.router.navigate([`/execution/v3/dashboard-pnrr`]);  
            }
            else {
                try {
                    const executionResponse: ExecutionResponse =
                        await this.projectService.addNewExecution(
                            receivedEntry.destination.new_parent,
                            receivedEntry.destination.parent_type === 'project',
                            receivedEntry.name,
                            receivedEntry.toolName,
                            tool.id,
                            receivedEntry.checked,
                            receivedEntry.companyName);
                    this.router.navigate([`/execution/${executionResponse.id_new_execution}/edit-pnrr`]);
                } catch (error) {
                    this.toastService.showError(error.error);
                    console.error('error =>', error);
                }
            }
            
        }
    }


    onClose_SFRModal_generator(tool) {
        return async (receivedEntry) => {
            // console.log(receivedEntry)
            try {
                //se non è checkata la flag "client input" si scade nel caso normale -> ritorniamo quello che ritornebbe il normal generator
                if (!receivedEntry.sfr_checked_client) {
                    return this.onClose_normalModal_generator(tool)(receivedEntry)
                }

                //altrimenti inviamo la mail
                const executionResponse: ExecutionResponse =
                    await this.projectService.addNewExecution(
                        receivedEntry.destination.new_parent,
                        receivedEntry.destination.parent_type === 'project',
                        receivedEntry.name,
                        tool.id,
                        receivedEntry.toolName,
                        receivedEntry.checked,
                        receivedEntry.companyName);

                const execution_link: string = executionResponse.id_new_execution
                this.sfr.sendCREATENotificationToClient(receivedEntry.clientemail_sfr, execution_link)

                this.toastService.showSuccess({
                    description: `An email has been sent to ` + receivedEntry.clientemail_sfr,
                    type: 'success'
                });

            } catch (error) {
                this.toastService.showError(error.error);
                console.error('error =>', error);
            }
        }
    }

    onClose_normalModal_generator(tool) {
        return async (receivedEntry) => {
            try { 
              // console.log('New exec')
                const executionResponse: ExecutionResponse =
                    await this.projectService.addNewExecution(
                        receivedEntry.destination.new_parent,
                        receivedEntry.destination.parent_type === 'project',
                        receivedEntry.name,
                        tool.id,
                        receivedEntry.toolName,
                        receivedEntry.checked,
                        receivedEntry.companyName);
                // console.log(tool);
                if (tool?.name == ToolType.DBT ){
                  this.router.navigate([`/execution/${executionResponse.id_new_execution}/data-breach`]);
                  return;
                };
                this.router.navigate([`/execution/${executionResponse.id_new_execution}/edit`]);
                
            } catch (error) {
                this.toastService.showError(error.error);
                console.error('error =>', error);
            }
        }
    }
}
